export const achievements = [
    "joined_community",
    "joined_group",
    "sent_text",
    "reacted_to_message",
    "set_bio",
    "set_avatar",
    "sent_direct_message",
    "received_direct_message",
    "edited_message",
    "deleted_message",
    "forwarded_message",
    "tipped_message",
    "sent_image",
    "sent_file",
    "sent_poll",
    "sent_crypto",
    "sent_video",
    "sent_audio",
    "sent_giphy",
    "sent_prize",
    "sent_meme",
    "started_call",
    "joined_call",
    "quote_replied",
    "replied_in_thread",
    "changed_theme",
    "upgraded_to_diamond",
    "set_community_display_name",
    "set_display_name",
    "sent_swap_offer",
    "streak_3",
    "streak_7",
    "streak_14",
    "streak_30",
    "streak_100",
    "streak_365",
    "sent_reminder",
    "proved_unique_personhood",
    "favourited_chat",
    "received_reaction",
    "voted_on_poll",
    "pinned_chat",
    "set_pin",
    "had_message_tipped",
    "swapped_from_wallet",
    "accepted_swap_offer",
    "followed_thread",
    "received_crypto",
    "upgrade_to_gold_diamond",
    "referred_1st_user",
    "referred_3rd_user",
    "referred_10th_user",
    "referred_20th_user",
    "referred_50th_user",
    "deposited_btc",
];
export const chitBands = new Map([
    [10_000, "10k"],
    [25_000, "25k"],
    [50_000, "50k"],
    [100_000, "100k"],
    [250_000, "250k"],
    [500_000, "500k"],
    [1_000_000, "1m"],
]);
export function findClosestChitBand(earned) {
    const keys = [...chitBands.keys()].sort((a, b) => b - a);
    return keys.find((k) => k <= earned) ?? 0;
}
export var PremiumItem;
(function (PremiumItem) {
    PremiumItem[PremiumItem["BotEmojis"] = 0] = "BotEmojis";
    PremiumItem[PremiumItem["PopularEmojis"] = 1] = "PopularEmojis";
    PremiumItem[PremiumItem["CustomProfileBackground"] = 2] = "CustomProfileBackground";
})(PremiumItem || (PremiumItem = {}));
export const premiumPrices = {
    [PremiumItem.BotEmojis]: 10_000,
    [PremiumItem.PopularEmojis]: 50_000,
    [PremiumItem.CustomProfileBackground]: 50_000,
};
